const moment = require('moment');
const { toCamelCase } = require('utilities/stringHelper');
// @ constants
const DateFormatTypes = require('../constants/dateFormatTypes');
const { DATE_FORMAT } = require('../constants/index');

const removeTimeFromDate = (date) => {
    return moment(date).hours(0).minutes(0).seconds(0);
};

const isToday = (date) => {
    const today = removeTimeFromDate(moment());

    date = removeTimeFromDate(date);

    return today.unix() === date.unix();
};

const isYesterday = (date) => {
    let yesterday = moment().subtract(1, 'days');

    yesterday = removeTimeFromDate(yesterday);
    date = removeTimeFromDate(date);

    return yesterday.unix() === date.unix();
};

const isCurrentYear = (date) => {
    return moment(date).year() === moment().year();
};

const getMonth = (date) => {
    return moment(date).month() + 1;
};

const getYear = (date) => {
    return moment(date).year().toString().substr(-2);
};

const getFullYear = (date) => {
    return moment(date).year();
};

const getMonthFullName = (monthValue, language) => {
    return moment().month(monthValue - 1).locale(language).format('MMMM');
};

const formatDate = (paramDate, language, format = DATE_FORMAT) => {
    let desiredFormat;
    // TODO: It uses es if language does not exist
    try {
        desiredFormat = DateFormatTypes[language][format];
    } catch(e) {
        desiredFormat = DateFormatTypes['es'][format];
    }

    let result = moment(paramDate).locale(language || 'es');

    if (desiredFormat) {
        result = result.format(desiredFormat);

        if (language == 'es' || language == 'en') {
            result = toCamelCase(result.replace('.', ''));
        }
    } else {
        result = result.format(format);
    }

    return result;
};

module.exports = {
    isToday,
    isYesterday,
    isCurrentYear,
    getMonth,
    getYear,
    getFullYear,
    getMonthFullName,
    formatDate
};
